<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>{{ __("Neuer Premium-Bereich cropspot+") }}</span>
		</template>
		<template v-slot:content>
			<div class="p-6">
				<div class="px-6">
					<p class="my-3">Liebe Nutzerin, lieber Nutzer,</p>

					<p>wir möchten Sie offen über eine wichtige Änderung auf cropspot informieren.</p>
					<p>Um unser Angebot kontinuierlich weiterzuentwickeln und Ihnen noch mehr Mehrwert bieten zu können, werden einige Bereiche von cropspot künftig kostenpflichtig.</p>
					<p class="mt-3 font-bold">Was bedeutet das konkret?</p>

					<ul class="list-disc p-4 sm:max-w-[80%]">
						<li>Grundlegende Funktionen wie inserieren und verhandeln bleiben weiterhin kostenlos.</li>
						<li>Bestimmte Inhalte und Funktionen werden ab dem 16.02.2026 Teil unseres neuen Premium-Angebots <span class="font-bold">cropspot+.</span></li>
						<li>Sie profitieren dort von unseren exklusiven Inhalten, erweiterten Funktionen, besseren Support sowie einem Freihandelskontingent von 150 Tonnen.</li>
					</ul>

					<p>Weitere Informationen zu Preisen, Leistungen und Buchungsmöglichkeiten von cropspot+ finden Sie hier:</p>
						<p class="my-3 text-orange"><page-link class="py-3 hover:text-orange-600" :href="$route('premium.index')" :absolute="true">👉  Testen Sie gern cropspot+ 30 Tage kostenlos</page-link>.
					</p>

					<p>Uns ist wichtig, diese Änderung transparent und fair umzusetzen. Wenn Sie Fragen haben oder uns Feedbackgeben möchten, freuen wir uns über Ihre Nachricht.</p>
					<p>Vielen Dank für Ihr Vertrauen und Ihre Unterstützung.</p>

					<p class="mt-3">Mit freundlichen Grüßen</p>
					<p>Ihr cropspot-Team</p>
				</div>
			</div>
			<div class="bg-gray-100 p-6 flex justify-end">
				<div>
					<ui-button
						type="primary"
						v-on:click="close()"
						label="OK – Schließen"
					></ui-button>
				</div>
			</div>
		</template>
	</ui-modal-template>
</template>

<script>
export default {
	data() {
		return {
			open: false,
		};
	},
	mounted() {
		this.open = true;
	},
	methods: {
		close() {
			this.$bus.$emit("modal:close");
		},
	},
};
</script>
